<template lang="pug">
.form-col.large-24
  label
    | {{ t('app.registration.transfer_info.list_versity_level_sport') }}
  table.versity-sports-table
    tbody
      tr(v-for="(sport, index) in varsity_info.varsity_sports.sports" :key="index")
        td
          validation-provider( 
            :rules="{ required: required && index === 0 }"
            v-slot="{ errors }"
            :ref="`sport_name_${index}`"
          )
            span.required(v-if="index === 0 && required") *
            label(:class="{ error: errors[0] }")
              | {{ t('app.registration.transfer_info.sport') }}
            select(
              v-model="sport.name"
              @change="onSelectSport($event, index)"
              :class="{ error: errors[0] }"
            )
              option(value="" disabled selected) {{ t('app.registration.transfer_info.select_sport') }}
              option(v-for="s in sports" :key="s.genericSportId" :value="s.genericSportName") {{ s.genericSportName }}
        td
          validation-provider(
            :rules="{ required: required && index === 0 }"
            v-slot="{ errors }"
            :ref="`sport_grade_${index}`"
          )
            span.required(v-if="index === 0 && required") *
            label(:class="{ error: errors[0] }")
              | {{ t('app.registration.transfer_info.grade_played') }}
            select(
              v-model="sport.grade_played"
              @change="onSelectGrade($event, index)"
              :class="{ error: errors[0] }"
            )
              option(value="" disabled selected) {{ t('app.registration.transfer_info.select_grade') }}
              option(v-for="grade in grades" :key="grade.value" :value="grade.value") {{ grade.value }}
        td
          span.required(v-if="index === 0 && required") *
          validation-provider.field.clearfix.datepicker(
            v-slot="{ errors }"
            :rules="{ required: required && index === 0 }"
            tag="div"
          )
            label(:class="{ error: errors[0] }") {{ get_last_day_of_varsity_participation.name }}
            span.description(v-if="get_last_day_of_varsity_participation.description")
              | {{ get_last_day_of_varsity_participation.description }}
            .input-group
              flat-pickr(
                v-model="sport.last_day_played"
                placeholder="mm-dd-yyyy"
                class="large-6"
                :config="datePickerOpts"
                @input="onSelectDate($event, index)"
              )
              .prefix.date
                span.icon-calendar
        td
          a.cancel-button(
            v-if="index > 0"
            @click.prevent="removeSportRow(index)"
            title="Remove"
          )
            span.icon-nested-remove
    tfoot
      tr
        td.add-more(colspan="3")
          span.icon-add-more
          span.add-more-text(v-if="enable_add_sport" @click.prevent="addSportRow") 
            | {{ t('app.registration.transfer_info.add_more') }}
</template>

<script>
import datepicker from '../../shared/_formatted_datepicker.vue';
import flatPickr from 'vue-flatpickr-component';
export default {
  components: {datepicker, flatPickr},
  props: {
    varsity_info: {
      type: Object,
      required: true,
    },
    enable_add_sport: {
      type: Boolean,
      default: true,
    },
    nested_fields: {
      type: Object,
      default() {
        return {};
      },
    },
    sports: {
      type: Array,
      default(){
        return []
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showErrors: false,
      datePickerOpts: {enableTime: false, dateFormat: 'Y-m-d',altFormat: 'm-d-Y',altInput:true, wrap: true, altInputClass:"flatpckr"},
      grades: [
        { value: '8th Grade' },
        { value: '9th Grade' },
        { value: '10th Grade' },
        { value: '11th Grade' },
        { value: '12th Grade' },
      ],
    };
  },
  computed: {
    get_last_day_of_varsity_participation() {
       return this.nested_fields.find(
        x => x.uid === "last_day_of_varsity_participation"
      ) ?? {};
    },
  },
  mounted() {
    if (!this.varsity_info.varsity_sports.sports || this.varsity_info.varsity_sports.sports.length === 0) {
      this.$set(this.varsity_info.varsity_sports, 'sports', []);
      this.addSportRow();
    }
  },
  beforeMount(){
    this.axios.get(`/api2/family/registrations/get_arbiter_generic_sports`).then((resp)=>{
      this.sports = resp.data.object.sort((a, b) => a.genericSportName.localeCompare(b.genericSportName));
    })
  },
  methods: {
    addSportRow() {
      const MAX_SPORT_ROWS = 10;

      if (this.varsity_info.varsity_sports.sports.length >= MAX_SPORT_ROWS) {
        this.enable_add_sport = false;
        return;
      }

      const emptySport = this.createEmptySport();
      this.varsity_info.varsity_sports.sports.push(emptySport);

      this.showErrors = true;
    },
    removeSportRow(index) {
      if (this.varsity_info.varsity_sports.sports.length <= 10) {
        this.enable_add_sport = true;
      }
      this.varsity_info.varsity_sports.sports.splice(index, 1);
    },
    createEmptySport() {
      return {
        name: '',
        grade_played: '',
        last_day_played: '',
      };
    },
    onSelectSport(event, index) {
      this.varsity_info.varsity_sports.sports[index].name = event.target.value;
    },
    onSelectGrade(event, index) {
      this.varsity_info.varsity_sports.sports[index].grade_played = event.target.value;
    },
  },
};
</script>
